import { mapEnumToOptions } from '@abp/ng.core';

export enum RecurrenceType {
  Periodic = 'PERIODIC',
  Adhoc = 'ADHOC',
}

export const recurrenceTypeOptions = mapEnumToOptions(RecurrenceType);
